import { useEffect } from "react";

function upsertMeta(attr, key, content) {
  const selector = `meta[${attr}="${key}"]`;
  let el = document.head.querySelector(selector);
  if (!content) {
    if (el) el.remove();
    return;
  }
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export default function Seo({ title, siteName = "BNM Sustainable Energy Limited", description, image, type = "website", jsonLd }) {
  useEffect(() => {
    const url = window.location.origin + window.location.pathname;
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.rel = "canonical";
      document.head.appendChild(link);
    }
    link.href = url;

    if (title) document.title = title;
    upsertMeta("name", "description", description);
    upsertMeta("property", "og:url", url);
    upsertMeta("property", "og:site_name", siteName);
    upsertMeta("property", "og:type", type);
    upsertMeta("property", "og:title", title);
    upsertMeta("property", "og:description", description);
    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:title", title);
    upsertMeta("name", "twitter:description", description);
    upsertMeta("property", "og:image", image ? window.location.origin + image : null);
    upsertMeta("name", "twitter:image", image ? window.location.origin + image : null);

    let script = document.head.querySelector("script[data-seo-jsonld]");
    if (jsonLd) {
      if (!script) {
        script = document.createElement("script");
        script.type = "application/ld+json";
        script.setAttribute("data-seo-jsonld", "true");
        document.head.appendChild(script);
      }
      script.textContent = JSON.stringify(jsonLd);
    } else if (script) {
      script.remove();
    }
  }, [title, siteName, description, image, type, jsonLd]);

  return null;
}
